import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=anon, obj=auth
  const [token, setToken] = useState(localStorage.getItem("l19_token") || null);

  useEffect(() => {
    const check = async () => {
      if (!token) { setUser(false); return; }
      try {
        const { data } = await api.get("/auth/me", { headers: { Authorization: `Bearer ${token}` } });
        setUser(data);
      } catch (error) {
        if (error?.response?.status !== 401) console.error("Auth check failed:", error);
        setUser(false);
      }
    };
    check();
  }, [token]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.token) {
      localStorage.setItem("l19_token", data.token);
      setToken(data.token);
    }
    setUser(data);
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (error) { console.error("Logout failed:", error); }
    localStorage.removeItem("l19_token");
    setToken(null);
    setUser(false);
  };

  const authHeaders = token ? { Authorization: `Bearer ${token}` } : {};

  const value = useMemo(() => ({ user, login, logout, authHeaders }), [user, token]);

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
export { formatApiErrorDetail };
